import { useAuth, type MeUser } from "./store";

/**
 * 조직 기능 사용 플래그 (2026-09-30) — 서버 `identity/features.py` 와 같은 키·기본값(전부 끔).
 *
 *   cctv             설치된 카메라 없음 → 메뉴·라우트·트윈 CCTV 레이어 숨김
 *   hvac_integration 현장 공조설비(환기·공조) 연동 — 끄면 제어 대상·도면 표시에서 빠진다
 *   dispatch_119     119 신고 대응(확인·기록 게이트, 모의) — 끄면 게이트 카드 숨김
 *
 * 값은 로그인·`/auth/me` 의 `organization.features` 로 온다(추가 요청 없음). 이건 UX 게이트이고
 * 진짜 규칙은 서버가 지킨다(`RequireRole` 과 같은 관계).
 */
export type FeatureKey = "cctv" | "hvac_integration" | "dispatch_119";

export const FEATURE_KEYS: readonly FeatureKey[] = ["cctv", "hvac_integration", "dispatch_119"];

/** 공조 연동에 딸린 장치 종류(SiteDevice.kind). */
export const HVAC_DEVICE_KINDS: ReadonlySet<string> = new Set(["ventilation", "hvac"]);

/** 옛 캐시 사용자(필드 없음)·조직 없는 계정 = 끔 — 서버 기본값과 같다. */
export function featureOn(user: MeUser | null | undefined, k: FeatureKey): boolean {
  return user?.organization?.features?.[k] === true;
}

export function useFeature(k: FeatureKey): boolean {
  return useAuth((s) => s.user?.organization?.features?.[k] === true);
}
